import React, { FC, useEffect } from 'react';
import './style.scss';
import { TSolutionsProps } from './types/solutions.types';
import { documentService, windowService } from '../../../utils/window.utils';
import SolutionCard from './component/solutionCard';
import { modelSolution } from '../../../constants/hash-route.constants';
import TextComponentDecider from '../TextComponentDecider';
import { getTextType } from '../../../utils/getTextType.utils';

const Solutions: FC<TSolutionsProps> = (props: TSolutionsProps) => {
  const { title = '', fields = [], titleDictionaryKey } = props;

  useEffect(() => {
    const locationHref = windowService().location.href;
    if (locationHref.includes('#') && locationHref.split('#')[1] === modelSolution) {
      documentService().getElementsByClassName(modelSolution)[0]?.scrollIntoView({ behavior: 'smooth' });
    }
  }, []);

  return (
    <div className={`${modelSolution} solutions-wrapper product-white-spacer`}>
      <div className="solutions">
        <TextComponentDecider
          type={getTextType('Text', !title)}
          tag={'h2'}
          field={{ value: title }}
          className="solutions__title"
          dictionaryKey={titleDictionaryKey}
        />
        {fields.length > 0 && (
          <div className="solutions__cards-wrapper">
            {fields.map((item, index) => (
              <article key={index} className="solutions-card">
                <SolutionCard cardItem={item} />
              </article>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default React.memo(Solutions);
